import React, { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import storage from "../utils/storage";
import LoginModal from "../pages/Login/LoginModal";
import Swal from "sweetalert2";
import LeadService from "../services/LeadService";

const SideBar = () => {
  const navigate = useNavigate();
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [token, setToken] = useState("");
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const token = storage.getAccessToken();
    if (token) {
      setToken(token);
      setIsLoggedIn(true);
    }
  }, []);

  const handleLoginClick = () => setShowModal(true);

  const prepaidCardUrl = ``;
  const applyCreditCardUrl = ``;

  // Async function for Apply Credit Card
  const handleApplyCreditCardClick = useCallback(async () => {
    console.log("Apply Credit Card clicked. Performing async operation...");

    try {
      const result = await LeadService.getRedirectUrl();

      if (!result.success) {
        Swal.fire("Oops!", result.message, "error");
        return;
      }

      const responseData = result.data;

      if (responseData.status === "SUCCESS") {
        const data = responseData.data;
        Swal.close(); // Close the loading modal

        window.open(data.redirect_url, "_blank"); // Open in new tab
      } else {
        Swal.fire("Oops!", responseData.message, "error");
      }
    } catch (error) {
      Swal.fire(
        "Oops!",
        error.response?.data?.message || error.message,
        "error",
      );
    }
  }, [applyCreditCardUrl]);

  const handleNavigation = useCallback(
    (item) => {
      if (item.required_logged_in && !isLoggedIn) {
        handleLoginClick();
        return;
      }

      if (item.label === "Apply Credit Card") {
        handleApplyCreditCardClick();
      } else if (item.target === "_blank") {
        window.open(item.href, "_blank");
      } else {
        navigate(item.href);
      }
    },
    [isLoggedIn, navigate, handleApplyCreditCardClick],
  );

  const menuItems = [
    {
      label: "Recharge and Bill Payment",
      icon: "/assets/images/mobile-icon.png",
      href: "/recharge-and-bill-payment",
      required_logged_in: true,
      group: "group1",
    },
    {
      label: "NSDL PAN Card",
      icon: "/assets/images/nsdl_logo.png",
      href: "/nsdl-pancard",
      required_logged_in: true,
      group: "group1",
    },
    {
      label: "UTI PAN Card",
      icon: "/assets/images/uti_logo.png",
      href: "/uti-pancard",
      required_logged_in: true,
      group: "group1",
    },
    {
      label: "UTI PAN Card (E-Wallet)",
      icon: "/assets/images/uti_logo.png",
      href: "/uti-pancard/e-wallet",
      required_logged_in: true,
      group: "group1",
    },
    {
      label: "Insurance POSP",
      icon: "/assets/images/insurance-2-icon.png",
      href: "/insurance-posp",
      required_logged_in: true,
      group: "group1",
    },
    {
      label: "Banking & Financial",
      icon: "/assets/images/bank-icon.png",
      href: "/banking-services",
      required_logged_in: true,
      group: "group1",
    },
    // {
    //   label: "Fino Money Transfer",
    //   icon: "/assets/images/money_transfer_icon.png",
    //   href: "/fino-money-transfer",
    //   required_logged_in: true,
    //   group: "group1",
    // },
    // {
    //   label: "CMS",
    //   icon: "/assets/images/money_transfer_icon.png",
    //   href: "/cms",
    //   required_logged_in: true,
    //   group: "group1",
    // },
    // {
    //   label: "Prepaid Card",
    //   icon: "/assets/images/prepaid-card-2-icon.png",
    //   href: prepaidCardUrl,
    //   target: "_blank",
    //   required_logged_in: true,
    //   group: "group1",
    // },
    // {
    //   label: "Insurance",
    //   icon: "/assets/images/insurance-2-icon.png",
    //   href: "/insurance",
    //   required_logged_in: true,
    //   group: "group1",
    // },
    // {
    //   label: "Credit Card to Bank Transfer",
    //   icon: "/assets/images/tap-to-pay-icon.png",
    //   href: "/credit-card-to-bank-transfer",
    //   required_logged_in: true,
    //   group: "group1",
    // },
    // {
    //   label: "Apply Credit Card",
    //   icon: "/assets/images/gift-card-icon.png",
    //   href: applyCreditCardUrl,
    //   target: "_blank",
    //   required_logged_in: true,
    //   group: "group1",
    // },
    {
      label: "My Wallet",
      icon: "/assets/images/ewallet-icon.png",
      href: "/wallet",
      required_logged_in: true,
      group: "group2",
    },
    {
      label: "Help and Support",
      icon: "/assets/images/customer-service-icon.png",
      href: "/support",
      required_logged_in: false,
      group: "group3",
    },
  ];

  const groupConfig = {
    group1: { bgColor: "#f6f2ff", textColor: "#4a3f6b" },
    group2: { bgColor: "#e9f5ff", textColor: "#2c78bf" },
    group3: { bgColor: "#f6f2ff", textColor: "#f08a00" },
  };

  const renderGroupItems = (groupName) => {
    const { bgColor, textColor } = groupConfig[groupName];
    return (
      <div
        style={{
          backgroundColor: bgColor,
          borderRadius: "10px",
          marginTop: groupName !== "group1" ? "10px" : "0",
        }}
      >
        {menuItems
          .filter((item) => item.group === groupName)
          .map((item, index) => (
            <a
              key={index}
              onClick={() => handleNavigation(item)}
              className="d-flex align-items-center mb-0 text-decoration-none"
              style={{
                color: textColor,
                fontWeight: 600,
                borderRadius: "10px",
                display: "block",
                padding: "12px",
                cursor: "pointer",
              }}
            >
              <img
                src={item.icon}
                alt={item.label}
                style={{ width: 30, height: 30, marginRight: 15 }}
              />
              <span>{item.label}</span>
            </a>
          ))}
      </div>
    );
  };

  return (
    <div className="col-md-3 mb-3">
      <div className="card mb-4 shadow-sm rounded-4">
        <div className="card-body">
          {renderGroupItems("group1")}
          {renderGroupItems("group2")}
          {renderGroupItems("group3")}
        </div>
      </div>

      <LoginModal
        show={showModal}
        onHide={() => setShowModal(false)}
        onLoginSuccess={() => setIsLoggedIn(true)}
      />
    </div>
  );
};

export default SideBar;
